<template>
  <b-dropdown :triggers="['hover']" aria-role="list" position="is-bottom-left">
    <template #trigger>
      <button class="button is-light" slot="trigger" @click.stop>
        Gou<span style="position: relative; top: 3px;">!!</span>
      </button>
    </template>

    <b-dropdown-item aria-role="listitem">
      <b>{{ $t("common.email") }}: </b>

      <a
        v-if="user && user.personalInfo && user.personalInfo.email"
        :href="`mailto:${user.personalInfo.email}`"
        target="_blank"
      >
        {{ user.personalInfo.email }}
      </a>

      <p>-</p>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
export default {
  props: ["user"]
};
</script>
